import { fileUrl } from '@/functions/fileUrl';
import { AssistantToolResult } from '../../interfaces/Assistant';

/** Artefact de raport (fișier generat) întors de tool-ul generateReport. */
export interface ReportArtifact {
  kind: 'xlsx' | 'pdf';
  title: string;
  filename: string;
  /** Cale relativă sub uploads/, servită la `${VITE_BACKEND_URI}/file/<filePath>`. */
  filePath: string;
  rowCount: number;
  total?: number;
  hasMore?: boolean;
  columns: { key: string; label: string }[];
  previewRows: string[][];
}

/** URL-ul de descărcare/preview pentru un artefact (ruta autentificată /file, cu token). */
export function artifactUrl(a: ReportArtifact): string {
  return fileUrl(a.filePath);
}

/** Extrage artefactele de raport din rezultatele tool-urilor unui mesaj. */
export function extractArtifacts(results?: AssistantToolResult[]): ReportArtifact[] {
  if (!results) return [];
  const artifacts: ReportArtifact[] = [];
  for (const r of results) {
    const out = r.output as { artifact?: Partial<ReportArtifact> } | undefined;
    const a = out?.artifact;
    if (a && a.filePath && (a.kind === 'xlsx' || a.kind === 'pdf') && Array.isArray(a.columns)) {
      artifacts.push({
        kind: a.kind,
        title: a.title || 'Raport',
        filename: a.filename || 'raport',
        filePath: a.filePath,
        rowCount: a.rowCount ?? 0,
        total: a.total,
        hasMore: a.hasMore,
        columns: a.columns as { key: string; label: string }[],
        previewRows: (a.previewRows as string[][]) || [],
      });
    }
  }
  return artifacts;
}
